var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.208 12.2939C20.208 11.6877 20.1536 11.1047 20.0525 10.5451H12V13.8524H16.6015C16.4032 14.9211 15.8009 15.8266 14.8953 16.4329V18.5782H17.6585C19.2753 17.0897 20.208 14.8978 20.208 12.2939Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.6496C14.3085 20.6496 16.2439 19.884 17.6585 18.5782L14.8953 16.4329C14.1297 16.9459 13.1503 17.249 12 17.249C9.77308 17.249 7.88819 15.745 7.21585 13.7241H4.35938V15.9393C5.76624 18.7336 8.65769 20.6496 12 20.6496Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21608 13.7241C7.04508 13.2111 6.94792 12.6631 6.94792 12.0996C6.94792 11.5361 7.04508 10.9881 7.21608 10.4751V8.25989H4.3596C3.78054 9.41414 3.4502 10.72 3.4502 12.0996C3.4502 13.4793 3.78054 14.7851 4.3596 15.9393L7.21608 13.7241Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.95017C13.2553 6.95017 14.3823 7.38156 15.2684 8.22879L17.7207 5.77649C16.24 4.39683 14.3046 3.54961 12 3.54961C8.65769 3.54961 5.76624 5.46558 4.35938 8.25988L7.21585 10.4751C7.88819 8.4542 9.77308 6.95017 12 6.95017Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.ab0118dc37758e9318f50c28aa10bda7.svg";
export { ForwardRef as ReactComponent };